import React from 'react';
import { Box, Container } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MobileColumnLayout from './MobileColumnLayout';
import DesktopLayout from './DesktopLayout';
import MobileBottomTabBar from './MobileBottomTabBar';
import { HEADER_HEIGHT, PADDING } from '../../constants';

const MainLayoutContainer = ({
  // 스와이프 관련
  activeColumn,
  setActiveColumn,
  swipeHandlers,
  
  // 비디오 관련
  isStreaming,
  analyzedVideoId,
  analyzedTitle,
  analyzedUrl,
  selectedHistory,
  onPlayerStateChange,
  playerRef,
  
  // 자막 관련
  scriptArr,
  activeIdx,
  autoScroll,
  setAutoScroll,
  scriptRefs,
  transcriptLoading,
  showTranslated,
  handleToggleTranslation,
  currentTranscript,
  
  // 요약 관련
  loading,
  streamingSummary,
  streamingChapters,
  activeTab,
  setActiveTab,
  streamingChunkSummaries,
  
  // QA 관련
  qaInput,
  setQaInput,
  qaLoading,
  handleQaSend,
  qaHistory,
  recommendedQuestions,
  handleRecommendedQuestionClick,
  qaScrollRef
}) => {
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <Box sx={{
        position: 'fixed',
        top: isMobile ? 'calc(56px + env(safe-area-inset-top, 0px))' : `${HEADER_HEIGHT}px`,
        left: 0,
        right: 0,
        bottom: isMobile ? 'calc(60px + env(safe-area-inset-bottom) - 18px)' : 0,
        bgcolor: '#f5f5f5',
        overflow: 'hidden',
        py: isMobile ? 0 : 3
      }}>
        <Container maxWidth={false} sx={{ px: 0, pt: 0, pb: 0, height: '100%' }}>
          <Box sx={{ height: '100%', p: isMobile ? 0 : `${PADDING}px` }}>
            {isMobile ? (
              <MobileColumnLayout
                activeColumn={activeColumn}
                swipeHandlers={swipeHandlers}
                // 비디오 관련
                isStreaming={isStreaming}
                analyzedVideoId={analyzedVideoId}
                analyzedTitle={analyzedTitle}
                analyzedUrl={analyzedUrl}
                selectedHistory={selectedHistory}
                onPlayerStateChange={onPlayerStateChange}
                playerRef={playerRef}
                // 자막 관련
                scriptArr={scriptArr}
                activeIdx={activeIdx}
                autoScroll={autoScroll}
                setAutoScroll={setAutoScroll}
                scriptRefs={scriptRefs}
                transcriptLoading={transcriptLoading}
                showTranslated={showTranslated}
                handleToggleTranslation={handleToggleTranslation}
                currentTranscript={currentTranscript}
                // 요약 관련
                loading={loading}
                streamingSummary={streamingSummary}
                streamingChapters={streamingChapters}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                streamingChunkSummaries={streamingChunkSummaries}
                setActiveColumn={setActiveColumn}
                // QA 관련
                qaInput={qaInput}
                setQaInput={setQaInput}
                qaLoading={qaLoading}
                handleQaSend={handleQaSend}
                qaHistory={qaHistory}
                recommendedQuestions={recommendedQuestions}
                handleRecommendedQuestionClick={handleRecommendedQuestionClick}
                qaScrollRef={qaScrollRef}
              />
            ) : (
              <DesktopLayout
                // 비디오 관련
                isStreaming={isStreaming}
                analyzedVideoId={analyzedVideoId}
                analyzedTitle={analyzedTitle}
                analyzedUrl={analyzedUrl}
                selectedHistory={selectedHistory}
                onPlayerStateChange={onPlayerStateChange}
                playerRef={playerRef}
                // 자막 관련
                scriptArr={scriptArr}
                activeIdx={activeIdx}
                autoScroll={autoScroll}
                setAutoScroll={setAutoScroll}
                scriptRefs={scriptRefs}
                transcriptLoading={transcriptLoading}
                showTranslated={showTranslated}
                handleToggleTranslation={handleToggleTranslation}
                currentTranscript={currentTranscript}
                // 요약 관련
                loading={loading}
                streamingSummary={streamingSummary}
                streamingChapters={streamingChapters}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                streamingChunkSummaries={streamingChunkSummaries}
                // QA 관련
                qaInput={qaInput}
                setQaInput={setQaInput}
                qaLoading={qaLoading}
                handleQaSend={handleQaSend}
                qaHistory={qaHistory}
                recommendedQuestions={recommendedQuestions}
                handleRecommendedQuestionClick={handleRecommendedQuestionClick}
                qaScrollRef={qaScrollRef}
              />
            )}
          </Box>
        </Container>
      </Box>
      
      {/* 모바일 전용 하단 플로팅 탭 바 */}
      {isMobile && (
        <MobileBottomTabBar
          activeColumn={activeColumn}
          setActiveColumn={setActiveColumn}
        />
      )}
    </>
  );
};

export default MainLayoutContainer; 